export const state = function () {
  return {
    isTransitioningToSignup: false,
  }
}

export const mutations = {
  SET_TRANSITIONING_STATUS(state, boolean) {
    state.isTransitioningToSignup = boolean
  },
}
